import React from "react";
import { Card, Col } from "react-bootstrap";
import Facebook from "./Facebook";
import "./index.css";


export default function Integracoes() {

  return (
    <div className="integracao_pagina px-4">
      <div className="row">
        <div className="col-12">
          <div className="tituloPagina">Integrações</div>
        </div>
      </div>
      <div className="row">
        <Col md="6" className="mb-4">
          <Card className="p-4 cardIntegracao h-100">
            <Card.Header>Facebook</Card.Header>
            <Facebook />
          </Card>
        </Col>
      </div>
    </div>
  );
}

